<template>
	<div align="center">
		<v-img src="@/assets/progresa.png" id="imgProgresa"> </v-img>
		<p class="ma-5 text-justify">
			Este programa tiene el objetivo de ofrecerle a los estudiantes que se encuentran en su
			primer período de estudios universitarios, un conjunto de herramientas para aprovechar
			al máximo sus destrezas, facilitar el inicio y adaptación del medio universitario, de
			forma que puedan lograr el mejor rendimiento académico.
		</p>
		<v-btn color="primary" :to="{ name: 'Asesores' }">
			Conoce a quienes dan asesorías
			<v-icon>
				mdi-chevron-right
			</v-icon>
		</v-btn>
		<p class="ma-5 text-justify">
			Por tal razón, se creó la figura de profesor y estudiante asesor. Ellos, en un horario
			específico, les brindarán asesorias en las materias donde presentan mayor dificultad.
		</p>
	</div>
</template>

<script>
export default {};
</script>

<style>
@media screen and (min-width: 480px) {
	#imgProgresa {
		max-width: 40%;
	}
}
@media screen and (max-width: 480px) {
	#imgProgresa {
		max-width: 85%;
	}
}
</style>
